module.exports = __webpack_public_path__ + "static/img/a065.353aad8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a065.jpg
// module id = EtQl
// module chunks = 0